export default class ToggleTrialReferrer {
    constructor() {
        const OTHER = "other";
        const $toggle = $("#toggle-trial-referrer-other");
        this.$target = $("#trial-referrer-other");

        $toggle.on("change", ({ target }) => {
            this.toggle(target.value != OTHER);
        });
        window.addEventListener("load", () => {
            this.toggle($toggle.val() != OTHER);
        });
    }
    toggle(value) {
        this.$target.attr("hidden", value);
    }
}
